import * as React from 'react';
import { Body1 } from '@cian/ui-kit';

import * as styles from './AboutRealtorMobileSection.css';

import type { JSX } from 'react';

interface IProps {
  pictureElement: JSX.Element;
  title: string;
  text: string;
}

export const AboutRealtorMobileSection = ({ pictureElement, title, text }: IProps) => (
  <div className={styles['container']}>
    <div className={styles['icon']}>{pictureElement}</div>
    <div className={styles['text']}>
      <Body1 color="text-secondary-default">{title}</Body1>
      <br />
      <Body1>{text}</Body1>
    </div>
  </div>
);
